/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { 
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter 
} from './ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Switch } from './ui/switch';
import {
  Package, Plus, Edit3, Trash2, Copy, Users, CreditCard, Wallet, Coins,
  TrendingUp, Shield, Building, Briefcase, Eye, UserPlus, Check, X,
  Loader2, Search, Filter, BarChart3, Settings, Zap, Star, Crown,
  ChevronRight, ArrowRight, Sparkles, Target, Award, Clock, Calendar,
  PieChart, Activity, Info, AlertCircle, CheckCircle2, RefreshCw, ShoppingCart, Receipt
} from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import StripeCheckoutButton from './StripeCheckoutButton';
import { getToken, getAuthHeader as getStoredAuthHeader } from '../services/tokenService';
import InstitutionalHero from './ui/InstitutionalHero';


export const GestionPlansAssignmentsTab = ({ ctx }) => {
  const {
    activeTab, assignForm, assignPlanSearch, assignUserSearch, assignmentSearch,
    assignmentStatusFilter, assignments, dialogStep, editingPlan, filterRole, filterType,
    loading, planForm, plans, saving, searchTerm, selectedPlan, selectedPlanIds,
    showAssignDialog, showDetailDialog, showPlanDialog, users,
    setActiveTab, setAssignForm, setAssignPlanSearch, setAssignUserSearch, setAssignmentSearch,
    setAssignmentStatusFilter, setAssignments, setDialogStep, setEditingPlan, setFilterRole,
    setFilterType, setLoading, setPlanForm, setPlans, setSaving, setSearchTerm, setSelectedPlan,
    setSelectedPlanIds, setShowAssignDialog, setShowDetailDialog, setShowPlanDialog, setUsers,
    fetchAssignments, fetchPlans, fetchUsers, filteredPlans, getAuthHeader, getPricingTypeConfig,
    getRoleConfig, handleAssignPlan, handleBulkDeletePlans, handleBulkToggleActive, handleDeletePlan,
    handleDuplicatePlan, handleSavePlan, openCreateDialog, openDetailDialog, openEditDialog,
    renderPlanPrice, stats, togglePlanSelection, toggleSelectAllPlans,
    PRICING_TYPES, TARGET_ROLES, DEFAULT_PLAN, PLAN_COLORS, getErrorMessage,
  } = ctx;
  return (
        <TabsContent value="assignments" className="space-y-4">
          {/* Header card */}
          <Card className="border-2 border-slate-200 shadow-sm">
            <CardContent className="p-5">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                <div className="flex items-center gap-4">
                  <div className="p-3 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 shadow-md">
                    <Users className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-slate-800">Assignations de Plans</h3>
                    <p className="text-sm text-slate-500">
                      {assignments.length} assignation{assignments.length > 1 ? 's' : ''} au total
                      · <span className="text-emerald-700 font-medium">{assignments.filter(a => a.statut === 'actif').length} actif{assignments.filter(a => a.statut === 'actif').length > 1 ? 's' : ''}</span>
                    </p>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
                  <div className="relative flex-1 sm:w-72">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
                    <Input
                      placeholder="Rechercher utilisateur ou plan…"
                      className="pl-10 h-10"
                      value={assignmentSearch}
                      onChange={(e) => setAssignmentSearch(e.target.value)}
                      data-testid="assignments-search"
                    />
                  </div>
                  <Select value={assignmentStatusFilter} onValueChange={setAssignmentStatusFilter}>
                    <SelectTrigger className="h-10 w-40" data-testid="assignments-status-filter">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">Tous statuts</SelectItem>
                      <SelectItem value="actif">Actif</SelectItem>
                      <SelectItem value="suspendu">Suspendu</SelectItem>
                      <SelectItem value="expire">Expiré</SelectItem>
                    </SelectContent>
                  </Select>
                  <Button onClick={() => setShowAssignDialog(true)} className="h-10 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white shadow-md whitespace-nowrap" data-testid="assignments-new-btn">
                    <UserPlus className="h-4 w-4 mr-2" />
                    Nouvelle assignation
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border border-slate-200 shadow-sm overflow-hidden">
            <CardContent className="p-0">
              {(() => {
                const q = assignmentSearch.toLowerCase().trim();
                const filtered = assignments.filter((a) => {
                  if (assignmentStatusFilter !== 'all' && a.statut !== assignmentStatusFilter) return false;
                  if (!q) return true;
                  const u = a.user || {};
                  const p = a.plan || {};
                  return (
                    (u.nom || '').toLowerCase().includes(q) ||
                    (u.prenom || '').toLowerCase().includes(q) ||
                    (u.email || '').toLowerCase().includes(q) ||
                    (p.nom || '').toLowerCase().includes(q)
                  );
                });
                if (filtered.length === 0) {
                  return (
                    <div className="py-16 text-center">
                      <div className="p-4 bg-slate-100 rounded-full w-fit mx-auto mb-4">
                        <UserPlus className="h-10 w-10 text-slate-400" />
                      </div>
                      <h3 className="font-semibold text-slate-700 mb-2">
                        {assignments.length === 0 ? 'Aucune assignation' : 'Aucun résultat'}
                      </h3>
                      <p className="text-sm text-slate-500">
                        {assignments.length === 0
                          ? 'Commencez par assigner un plan à un utilisateur'
                          : 'Essayez d\'élargir vos filtres'}
                      </p>
                    </div>
                  );
                }
                return (
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead className="bg-gradient-to-r from-slate-50 to-slate-100 border-b-2 border-slate-200">
                        <tr>
                          <th className="text-left px-4 py-3.5 text-xs font-bold text-slate-700 uppercase tracking-wider">Utilisateur</th>
                          <th className="text-left px-4 py-3.5 text-xs font-bold text-slate-700 uppercase tracking-wider">Plan</th>
                          <th className="text-left px-4 py-3.5 text-xs font-bold text-slate-700 uppercase tracking-wider">Crédits / Solde</th>
                          <th className="text-left px-4 py-3.5 text-xs font-bold text-slate-700 uppercase tracking-wider">Statut</th>
                          <th className="text-left px-4 py-3.5 text-xs font-bold text-slate-700 uppercase tracking-wider">Date début</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {filtered.map((assignment) => (
                          <tr key={assignment.id} className="hover:bg-purple-50/40 transition-colors" data-testid={`assignment-row-${assignment.id}`}>
                            <td className="px-4 py-3">
                              <div className="flex items-center gap-3">
                                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 text-white flex items-center justify-center font-bold text-xs shadow-sm">
                                  {(assignment.user?.prenom || '?')[0]}{(assignment.user?.nom || '?')[0]}
                                </div>
                                <div className="min-w-0">
                                  <div className="font-semibold text-slate-800 truncate">{assignment.user?.prenom} {assignment.user?.nom}</div>
                                  <div className="text-xs text-slate-500 truncate">{assignment.user?.email}</div>
                                </div>
                              </div>
                            </td>
                            <td className="px-4 py-3">
                              <Badge
                                className="font-medium border"
                                style={{
                                  backgroundColor: `${assignment.plan?.couleur}15`,
                                  color: assignment.plan?.couleur,
                                  borderColor: `${assignment.plan?.couleur}40`
                                }}
                              >
                                <span className="w-2 h-2 rounded-full mr-1.5" style={{ backgroundColor: assignment.plan?.couleur }} />
                                {assignment.plan?.nom}
                              </Badge>
                            </td>
                            <td className="px-4 py-3">
                              <div className="flex flex-col gap-1">
                                {assignment.credits_restants !== null && assignment.credits_restants !== undefined && (
                                  <span className="flex items-center gap-1.5 text-xs">
                                    <Coins className="h-3.5 w-3.5 text-yellow-500" />
                                    <span className="font-semibold text-slate-700">{assignment.credits_restants}</span>
                                    <span className="text-slate-500">crédits</span>
                                  </span>
                                )}
                                {assignment.wallet_solde !== null && assignment.wallet_solde > 0 && (
                                  <span className="flex items-center gap-1.5 text-xs">
                                    <Wallet className="h-3.5 w-3.5 text-emerald-500" />
                                    <span className="font-semibold text-slate-700">{assignment.wallet_solde}€</span>
                                  </span>
                                )}
                                {(!assignment.credits_restants && !assignment.wallet_solde) && (
                                  <span className="text-xs text-slate-400">—</span>
                                )}
                              </div>
                            </td>
                            <td className="px-4 py-3">
                              <Badge className={`border-0 ${
                                assignment.statut === 'actif' ? 'bg-emerald-100 text-emerald-800' :
                                assignment.statut === 'suspendu' ? 'bg-orange-100 text-orange-800' :
                                assignment.statut === 'expire' ? 'bg-red-100 text-red-800' :
                                'bg-slate-100 text-slate-700'
                              }`}>
                                {assignment.statut === 'actif' && <CheckCircle2 className="h-3 w-3 mr-1" />}
                                {assignment.statut === 'suspendu' && <AlertCircle className="h-3 w-3 mr-1" />}
                                {assignment.statut?.charAt(0).toUpperCase() + assignment.statut?.slice(1)}
                              </Badge>
                            </td>
                            <td className="px-4 py-3">
                              <div className="flex items-center gap-1.5 text-xs text-slate-600">
                                <Calendar className="h-3.5 w-3.5 text-slate-400" />
                                {assignment.date_debut
                                  ? new Date(assignment.date_debut).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' })
                                  : '—'
                                }
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                );
              })()}
            </CardContent>
          </Card>
        </TabsContent>
  );
};

export default GestionPlansAssignmentsTab;
